export const data = [
  {
    id: 1,
    price: 200,
    name: "camera",
    brand: "Number A",
    category: "Number A",
    img: "https://images.unsplash.com/photo-1510127034890-ba27508e9f1c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Y2FtZXJhfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 2,
    price: 99,
    name: "hand bag",
    brand: "Brand 2",
    category: "Brand 2",
    img: "https://images.unsplash.com/photo-1598532163257-ae3c6b2524b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmFnfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 3,
    price: 150,
    name: "Bagpack",
    brand: "brand c",
    category: "Brand c",
    img: "https://images.unsplash.com/photo-1622560480654-d96214fdc887?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fGJhZ3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 4,
    price: 200,
    name: "Plant",
    brand: "miracle",
    category: "miracle",
    img: "https://images.unsplash.com/photo-1463320898484-cdee8141c787?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjF8fHBsYW50fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 5,
    price: 599,
    name: "bat",
    brand: "Number A",
    category: "Number A",
    img: "https://images.unsplash.com/photo-1624248257284-5c6a3060eb72?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8YmF0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 6,
    price: 250,
    name: "Packed Food",
    brand: "Brand 2",
    category: "Brand 2",
    img: "https://images.unsplash.com/photo-1642170883288-ad37a1f3f761?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NjB8fHBhY2tlZCUyMGZvb2R8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 7,
    price: 450,
    name: "lipstick",
    brand: "Brand C",
    category: "Brand C",
    img: "https://images.unsplash.com/photo-1571646034647-52e6ea84b28c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8bGlwc3RpY2t8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 8,
    price: 700,
    name: "cake",
    brand: "miracle",
    category: "miracle",
    img: "https://images.unsplash.com/photo-1542826438-bd32f43d626f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fGNha2V8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 9,
    price: 600,
    name: "cloth",
    brand: "Empty",
    category: "Empty",
    img: "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGNsb3RofGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 10,
    price: 52,
    name: "pasta",
    brand: "Number A",
    category: "Number A",
    img: "https://images.unsplash.com/photo-1555949258-eb67b1ef0ceb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHBhc3RhfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 11,
    price: 79,
    name: "noodles",
    brand: "Brand 2",
    category: "Brand 2",
    img: "https://images.unsplash.com/photo-1585032226651-759b368d7246?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bm9vZGxlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 12,
    price: 9000,
    name: "Air Plane",
    brand: "miracle",
    category: "miracle",
    img: "https://images.unsplash.com/photo-1559711533-0bef8fbef572?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8ODZ8fHBsYW5lfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 13,
    price: 800,
    name: "Gold",
    brand: "empty",
    category: "empty",
    img: "https://images.unsplash.com/photo-1610375461246-83df859d849d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Z29sZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 14,
    price: 350,
    name: "Diamond",
    brand: "Number A",
    category: "Number A",
    img: "https://images.unsplash.com/photo-1600119612651-0db31b3a7baa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8ZGlhbW9uZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 15,
    price: 950,
    name: "Ancient Picture",
    brand: "Brand 2",
    category: "Brand 2",
    img: "https://images.unsplash.com/photo-1517775040268-83cbbbd76cf0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8YW5jaWVudCUyMHBpY3R1cmV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 16,
    price: 850,
    name: "Car",
    brand: "Brand c",
    category: "Brand c",
    img: "https://images.unsplash.com/photo-1502877338535-766e1452684a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Y2FyfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 17,
    price: 750,
    name: "truck",
    brand: "miracle",
    category: "miracle",
    img: "https://images.unsplash.com/photo-1473445730015-841f29a9490b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8dHJ1Y2t8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 18,
    price: 299,
    name: "fish",
    brand: "empty",
    category: "empty",
    img: "https://images.unsplash.com/photo-1524704654690-b56c05c78a00?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8ZmlzaHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 19,
    price: 78,
    name: "bread",
    brand: "Number A",
    category: "Number A",
    img: "https://images.unsplash.com/photo-1549931319-a545dcf3bc73?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YnJlYWR8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 20,
    price: 90,
    name: "Biscuit",
    brand: "Brand 2",
    category: "Brand 2",
    img: "https://images.unsplash.com/photo-1589988802149-7f9cb13a468e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmlzY3VpdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 21,
    price: 1000,
    name: "Boat",
    brand: "miracle",
    category: "miracle",
    img: "https://images.unsplash.com/photo-1531012278403-e5db3b774373?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Ym9hdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 22,
    price: 1200,
    name: "Boat House",
    brand: "miracle",
    category: "miracle",
    img: "https://images.unsplash.com/photo-1583768522824-792bf08ef0bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Ym9hdCUyMGhvdXNlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
];

export const BrandFilter = [
  { id: 1, name: "Number A", checked: false },
  { id: 2, name: "Brand 2", checked: false },
  { id: 3, name: "Brand C", checked: false },
  { id: 4, name: "Miracle", checked: false },
  { id: 5, name: "Empty", checked: false },
];

export const categoryFilter = [
  { id: 1, name: "Number A", checked: false },
  { id: 2, name: "Brand 2", checked: false },
  { id: 3, name: "Brand C", checked: false },
  { id: 4, name: "Miracle", checked: false },
  { id: 5, name: "Empty", checked: false },
];

export const priceFilter = [
  { id: 1, name: "<$100", checked: false },
  { id: 2, name: "$100 - $199", checked: false },
  { id: 3, name: "$200 - $599", checked: false },
  { id: 4, name: "$600 - $999", checked: false },
  { id: 5, name: ">$1000", checked: false },
];

export const priceCategory = [
  { id: 1, name: "price high to low", selected: false },
  { id: 2, name: "price low to high", selected: false },
];
